import { KeyValue } from '@app/core/components/KeyValue';
import { auditReports } from '@mi-front/api-clients';
import { Seconds } from '@mi-front/core';
import { Duration, QueryView } from '@mi-front/ui';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useEvidenceExportPathFormats } from './useEvidenceExportPathFormats';

export const GipExportConfigInfo = ({
  config,
  inDialog,
}: {
  inDialog?: boolean;
  config: auditReports.GipEvidenceExportOptionsDto;
}) => {
  const pathFormats = useEvidenceExportPathFormats() ?? [];
  const definitionId = config.definitionId;
  const definitionQuery = auditReports.useGetReportDefinitionById(definitionId || '', {
    query: {
      enabled: !!definitionId,
    },
  });

  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid item xl={inDialog ? undefined : 3} lg={inDialog ? undefined : 4} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 3 }}>
            <FormattedMessage
              id="audit.gipReport.export.filesConfig"
              defaultMessage="Configuración de archivos"
            />
          </Typography>

          <Box mt={3}>
            <KeyValue
              label={
                <FormattedMessage
                  id="audit.gipReport.export.audioMatchIncludeBeforeLabel"
                  defaultMessage="Segundos a incluir antes del match"
                />
              }
            >
              <Duration seconds={config.audioMatchIncludeBefore as Seconds} />
            </KeyValue>
            <KeyValue
              label={
                <FormattedMessage
                  id="audit.gipReport.export.audioMatchIncludeAfterLabel"
                  defaultMessage="Segundos a incluir después del match"
                />
              }
            >
              <Duration seconds={config.audioMatchIncludeAfter as Seconds} />
            </KeyValue>
            {config.pathFormat?.formatId && (
              <KeyValue
                label={
                  <FormattedMessage
                    id="audit.gipReport.export.pathFormat"
                    defaultMessage="Formato de path"
                  />
                }
              >
                {pathFormats.find((f) => f.id === config.pathFormat!.formatId)?.label}
              </KeyValue>
            )}
            {config.pathFormat?.formatCustomText && (
              <KeyValue
                label={
                  <FormattedMessage
                    id="audit.gipReport.export.customTextInPath"
                    defaultMessage="Texto custom en path"
                  />
                }
              >
                {config.pathFormat.formatCustomText}
              </KeyValue>
            )}
          </Box>
        </Grid>
        <Grid item xl={inDialog ? undefined : 3} lg={inDialog ? undefined : 4} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 3 }}>
            <FormattedMessage
              id="audit.gipReport.export.xlsConfig"
              defaultMessage="Configuración de XLS"
            />
          </Typography>

          {definitionId ? (
            <QueryView query={definitionQuery} inline>
              {(definition) => (
                <KeyValue
                  label={
                    <FormattedMessage
                      id="audit.gipReport.export.definition"
                      defaultMessage="Plantilla"
                    />
                  }
                >
                  {definition.name}
                </KeyValue>
              )}
            </QueryView>
          ) : (
            <>
              {typeof config.excludeVersion !== 'undefined' && (
                <KeyValue
                  label={
                    <FormattedMessage
                      id="audit.gipReport.export.excludeVersion"
                      defaultMessage="Excluir versión"
                    />
                  }
                >
                  {config.excludeVersion ? (
                    <FormattedMessage id="common.yes" defaultMessage="Sí" />
                  ) : (
                    <FormattedMessage id="common.no" defaultMessage="No" />
                  )}
                </KeyValue>
              )}
              {typeof config.publicLink !== 'undefined' && (
                <KeyValue
                  label={
                    <FormattedMessage
                      id="audit.gipReport.export.publicLink"
                      defaultMessage="Incluir link público"
                    />
                  }
                >
                  {config.publicLink ? (
                    <FormattedMessage id="common.yes" defaultMessage="Sí" />
                  ) : (
                    <FormattedMessage id="common.no" defaultMessage="No" />
                  )}
                </KeyValue>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Stack>
  );
};
